// src/composer/animation.ts

export function applyBob(ctx: CanvasRenderingContext2D, t: number, size: number): void {
  const offsetY = Math.round(Math.sin(t * 1.4) * 0.6);
  if (offsetY === 0) return;
  // Relies on renderBuild having been called this frame to repaint clipped edge rows.
  const img = ctx.getImageData(0, 0, size, size);
  ctx.clearRect(0, 0, size, size);
  ctx.putImageData(img, 0, offsetY);
}

export function applyShimmer(
  ctx: CanvasRenderingContext2D,
  accentLight: string,
  t: number,
  size: number,
): void {
  const ar = parseInt(accentLight.slice(1, 3), 16);
  const ag = parseInt(accentLight.slice(3, 5), 16);
  const ab = parseInt(accentLight.slice(5, 7), 16);
  const img = ctx.getImageData(0, 0, size, size);
  const d = img.data;
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const i = (y * size + x) * 4;
      if (d[i] === ar && d[i+1] === ag && d[i+2] === ab && d[i+3] === 255) {
        const h = ((x * 7 + y * 13) % 628) / 100; // ≈ coordinate hash in [0, 2π)
        const factor = 0.85 + 0.15 * Math.sin(t * 2.5 + h);
        d[i]   = Math.round(d[i]   * factor);
        d[i+1] = Math.round(d[i+1] * factor);
        d[i+2] = Math.round(d[i+2] * factor);
      }
    }
  }
  ctx.putImageData(img, 0, 0);
}
